import {Component, inject, input, InputSignal, OnInit, output, OutputEmitterRef} from '@angular/core';
import {ServiceCase} from '../../../../core/service-case/models/service-case';
import {UserData} from '../../../../core/user/models/user-data';
import {UserService} from '../../../../core/user/services/user.service';
import {DsTagModule} from '@bmw-ds/components';
import {DatePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-service-case-for-vin-selection',
  templateUrl: './service-case-for-vin-selection.component.html',
  styleUrls: ['./shared-styles.scss'],
  imports: [DsTagModule, DatePipe, TranslateModule]
})
export class ServiceCaseForVinSelectionComponent implements OnInit {
  private readonly userService: UserService = inject(UserService);

  readonly existingServiceCaseSelected: OutputEmitterRef<ServiceCase> = output<ServiceCase>();

  readonly caseList: InputSignal<ServiceCase[]> = input<ServiceCase[]>(undefined);

  locale: string;

  ngOnInit(): void {
    this.userService.user$.subscribe((user: UserData) => this.locale = user?.getLocale());
  }

  caseSelected(serviceCase: ServiceCase): void {
    this.existingServiceCaseSelected.emit(serviceCase);
  }
}
